<div class="empty-state-wrap">
  <div class="empty-state-card">

    <div class="empty-state-icon">
      <img class="empty-state-img" src="/assets/e-commerce/icons/73.webp" alt="no data" />
    </div>

    <h2 class="empty-state-title">
      {{ "No data available" | transloco }}
    </h2>

    <p class="empty-state-subtitle">
      {{ "Try changing your search and search again" | transloco }}
    </p>

    <button class="empty-state-btn" routerLink="/search">
      {{ "search again" | transloco }}
    </button>
  </div>
</div>